import React from 'react';
import { ToolHeadState } from 'types/tools/ToolHeadState';
import getToolHeadStateLabel from 'util/getToolHeadStateLabel';
import StatusBadge from './StatusBadge';

interface Props {
  toolHeadState: ToolHeadState;
}

const ToolStatusBadge: React.FC<Props> = ({ toolHeadState }) => {
  return (
    <StatusBadge
      $variant={(() => {
        switch (toolHeadState) {
          case ToolHeadState.ACTIVE:
            return 'green';
          case ToolHeadState.DRAFT:
            return 'yellow';
          case ToolHeadState.INACTIVE:
            return 'gray';
          default:
            return 'gray';
        }
      })()}
    >
      {getToolHeadStateLabel(toolHeadState)}
    </StatusBadge>
  );
};

export default ToolStatusBadge;
